export const flattenRequestInfoByFetch = ({ fetchMostRecentBeforeStart, fetchMostRecentBeforeEnd, fetchFromStartToEnd, ...rest }) => {
    const infos = [];
    if (fetchMostRecentBeforeStart) {
        infos.push({
            ...rest,
            fetchMostRecentBeforeStart,
        });
    }
    if (fetchMostRecentBeforeEnd) {
        infos.push({
            ...rest,
            fetchMostRecentBeforeEnd,
        });
    }
    if (fetchFromStartToEnd) {
        infos.push({
            ...rest,
            fetchFromStartToEnd,
        });
    }
    return infos;
};
